 <div  *ngIf="!initialLoading; else loading" > 
 

        
           <div class="streams-page"  *ngIf="video" > 
  
<div class="row">
<div class="col-12">
		<h5 class="mainTitle">{{video.title}} <nb-icon (click)="openEditInfo()"  style="color: #929292; cursor:pointer;" [icon]="'edit-outline'" pack="eva"></nb-icon></h5> 
<div style="display:none"><app-stream-info #infoComponent [stream]="video"></app-stream-info></div>
</div>

</div>

    <div class="row">

    <div class="col-xs-12 col-md-7" >

        <nb-card>
              
            <nb-card-body> 
     <!----><div   class="streamVideoWrapper">

	<div *ngIf="!video.staticVideoInfo.complete" class="loadingWrapper">
		<div *ngIf="!video.staticVideoInfo.loaded" class="proccessWrapper"> 
			<div class="proccessContent">
			<div *ngIf="!video.staticVideoInfo.loading">
		<div *ngIf="video.staticVideoInfo.was_error">
 			<p class="text-danger">Сталася помилка обробки файлу</p>
		</div>
		<div style="display:flex">
		 		<div style="display:flex; margin:auto">
		<button nbButton status="success" (click)="openUploadModal()" >Завантажити відео</button>
		</div>
		</div>
</div>


		<div  *ngIf="video.staticVideoInfo.loading">Йде завантаження</div>
		</div>
		</div>


		<div *ngIf="video.staticVideoInfo.loaded || video.staticVideoInfo.in_proccess" class="proccessWrapper loaded"> 
 
			<div class="proccessContent">


			<div  *ngIf="video.staticVideoInfo.in_proccess">

				<div class="progressWrapper" style="width:100%">

					<div style="display:flex; margin-bottom:5px;">
						<div class="left">0%</div> <div style="display:flex;flex:1; text-align:center">
	<div style="display:flex; margin:auto;">Йде обробка: {{proccessingProgress}}%</div>
	</div> <div class="right">100%</div>
					</div>
					
					<div class="progressBar"> 
					  <nb-progress-bar [value]="proccessingProgress" status="success"></nb-progress-bar>
					</div>

					</div>

					<div style="text-align:center; font-size:12px; margin-top:5px; line-height:12px;">
						Відео обробляється на наших серверах і скоро з'явиться
					</div>
			

			</div>


			</div>
		</div>
 
</div>



	
		<div *ngIf="video.staticVideoInfo.complete">     
   <video-player-preview #video [hasSignal]="false" [src]="videoSrc"></video-player-preview></div>
 
        <div class="streamVideoControls"> 
		 

	 </div>

    </div> 

    <div class="streamRunningPanel">

 <div  *ngIf="video.stat"  style="display:flex; margin-right:auto; margin-top:auto; margin-bottom:auto;">
                
		<nb-icon  style="color: #929292;" [icon]="'eye-outline'" pack="eva"></nb-icon> <span style="margin:0px 5px 0px 3px; color: #929292;">{{video.stat?.visitors || 0}}</span>

<a href="/statistics/{{video._id}}"  style=" margin-left:10px;"  target="_blank"><nb-icon    [icon]="'pie-chart-outline'" pack="eva"></nb-icon></a>
            </div>

        <div class="streamRunning">
           

            <div class="settingsLinkWrapper" style="display: flex;">
  <a href="javascript:;"  style=" margin-left:10px;" (click)="openSettings()" ><nb-icon    [icon]="'settings-outline'" pack="eva"></nb-icon></a>
                
            </div>
            
            
        
        </div>


    </div>

</nb-card-body>
</nb-card>
            
    </div>

<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">



<div class="rightPanels" >


            <app-streamer-chat  [openSettingsCb]="openSettingsCb" [stream]="video"></app-streamer-chat>


             <app-stream-donate-control   [stream]="video"></app-stream-donate-control>
             <app-stream-sale-control [keysComponent]="keysComponent" [stream]="video"></app-stream-sale-control>

              <app-stream-keys-control #keysComponent [stream]="video"></app-stream-keys-control>




            <app-stream-unlock-form-setting-control [stream]="video"></app-stream-unlock-form-setting-control>   


		<app-stream-qr-toggle-control [stream]="video"></app-stream-qr-toggle-control>


    
</div>


    
    </div> 

    </div>
 

	
  
 
 




    <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card >
             
                <subtitles-control [stream]="video"></subtitles-control>

            </nb-card>
        </div>
        <div class="col-xs-12 col-md-5"></div>
    </div>
  
         
            <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card >
                <nb-card-header>
                    <span class="panelToggler"  [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('info')"	 (click)="panelVisibility.toggleVisibility('info')" >Інформація</span>
                </nb-card-header>

                <nb-card-body *ngIf="!panelVisibility.isUnvisible('info')" [@visibilityPanelAnimation]>
                <app-stream-info [stream]="video"></app-stream-info>
                </nb-card-body>

            </nb-card>
        </div>
        <div class="col-xs-12 col-md-5"></div>
    </div>
  
         

 <div class="row">
        <div class="col-xs-12 col-md-7">
          
           <nb-card>
           <nb-card-header>
                


		<div style="display:flex; align-items:center;">
			<div  style=" margin-right:10px ">Перегляд</div>

			<div style="display:flex; margin-left:auto;  margin-right:10px;">
 				<a target="_blank" style="font-weight:normal;" href="{{domain.protocol}}{{domain.name}}/watch?v={{video.publicIdentity}}">{{domain.protocol}}{{domain.name}}/watch?v={{video.publicIdentity}}</a>
 
			</div>
			
			  <a class="copyLink" href="javascript:;" style="margin-left: auto;" (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
				    ngxClipboard [cbContent]="domain.protocol+domain.name+'/watch?v='+video.publicIdentity"><i class="fa fa-copy"></i></a>
		</div>
           </nb-card-header> 
           </nb-card> 
      
        </div>
    </div>





<div class="row">
        <div class="col-xs-12 col-md-7">
          
           <nb-card>
           <nb-card-header>
                <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('embed')"	 (click)="panelVisibility.toggleVisibility('embed')" >Вбудовування</span>
           </nb-card-header>
           <nb-card-body *ngIf="!panelVisibility.isUnvisible('embed')"   [@visibilityPanelAnimation]>
 
		  <div style="margin-bottom:15px">
			<span>Відео. Пряме посилання і код вбудовування:</span><br/>
			  <a class="copyLink" target="_blank" href="{{frameCodeLink}}"  >{{frameCodeLink}}</a>

			<div class="streamPageInfo">{{frameCode}}</div>
			
		<div style="text-align:right;">
                <a class="copyLink"  href="javascript:;"  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
                ngxClipboard [cbContent]="frameCode">Копіювати код</a>
		</div>
  
		</div>

		  <div>
			<span>Чат. Пряме посилання і код вбудовування:</span><br/>
			  <a class="copyLink" target="_blank" href="{{frameChatCodeLink}}"  >{{frameChatCodeLink}}</a>

  			<div  class="streamPageInfo">{{frameChatCode}}</div>
		<div  style="text-align:right;">
                  
                <a class="copyLink"  href="javascript:;"  (cbOnSuccess)="showToastCopyClipboard('Скопійовано в буфер обміну')" 
                ngxClipboard [cbContent]="frameChatCode">Копіювати код</a>
               
                   </div> 
		</div>
 
 
        </nb-card-body>
           </nb-card> 
      
        </div>
    </div>

  





  <div class="row">
        <div class="col-xs-12 col-md-7">
            <nb-card>
          
                <nb-card-body>
		<div style="display:flex; align-items:center;">
			<div>Опублікувати в каналі?</div>

			<div style="display:flex; margin-left:auto">

				      <!--[disabled]="!video.staticVideoInfo.complete" -->
				   <nb-toggle  
				     labelPosition="left"
				      [(checked)]="publish"
				      (checkedChange)="togglePublish()" 
				      status="primary">
				      <span *ngIf="publish">Опубліковано</span>
				      <span *ngIf="!publish">Не опубліковано</span>
				    </nb-toggle>


			</div>
		</div>
		 </nb-card-body>
 	   </nb-card>
	</div> 

    </div>	



	

  <div class="row">
        <div class="col-xs-12 col-md-7">	
      <nb-card  *ngIf="authService.isAdmin()">
		      
	   <nb-card-header>
		 <span class="panelToggler"    [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('CDN')"	 (click)="panelVisibility.toggleVisibility('CDN')" >CDN</span>    
		   </nb-card-header> 
        <nb-card-body *ngIf="!panelVisibility.isUnvisible('CDN')"   [@visibilityPanelAnimation]>

    <cdn-control [stream]="video"></cdn-control>
</nb-card-body>
</nb-card>
      
    </div>
</div>
       
  
<div style="min-height:250px;"></div> 
 
    </div>
</div>

  
 
<ng-template #loading>
   <app-skeleton-page   [type]="'video'" ></app-skeleton-page>
<!--
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div>
-->
</ng-template> 

     


 
